import React from 'react';
import Link from 'gatsby-link';

const IndexPage = () => (
  <div style={{ background: 'black' }}>
    <svg
      viewBox="-146.01339491977478 -106 910.099416425151 200"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      style={{ width: 339, height: 74.4974, maxHeight: '100%' }}
    >
      <g
        transform="translate(-16.129032258064516 46.65591397849464) scale(1.8667861409796893)"
        fill="#FFFFFF"
      >
        <g id="line1">
          <path d="M52.992-35.928C52.992-46.512 44.280-52.056 33.264-52.056L13.680-52.056C10.872-52.056 8.640-49.752 8.640-47.016L8.640-5.040C8.640-2.232 10.944 0 13.680 0C16.488 0 18.792-2.232 18.792-5.040L18.792-19.440L29.952-19.440L43.056-2.016C44.064-0.720 45.576 0 47.088 0C49.896 0 52.128-2.232 52.128-5.112C52.128-6.120 51.840-7.200 51.120-8.136L41.400-20.592C48.384-22.608 52.992-28.368 52.992-35.928ZM42.768-35.928C42.768-30.528 39.960-28.512 33.840-28.512L18.792-28.512L18.792-42.984L33.480-42.984C39.600-42.984 42.768-40.968 42.768-35.928Z" />
          <path d="M99.943-20.016C99.943-30.744 92.167-39.024 81.799-39.024C70.783-39.024 62.647-30.744 62.647-19.296C62.647-8.208 70.711 0.360 82.087 0.360C88.207 0.360 93.031-1.728 95.911-4.968C96.559-5.760 96.919-6.624 96.919-7.704C96.919-10.224 95.119-11.808 92.887-11.808C91.663-11.808 90.511-11.160 89.935-10.656C88.351-9.288 86.551-7.200 81.871-7.200C75.535-7.200 72.079-11.736 72.079-15.696L95.623-15.696C98.143-15.696 99.943-17.784 99.943-19.872ZM72.223-23.184C72.223-27.144 75.751-31.536 81.871-31.536C87.271-31.536 90.799-27.144 90.799-23.184Z" />
          <path d="M127.166 0.360C132.206 0.360 136.382-1.944 138.470-4.320C138.470-3.168 139.406 0.072 143.006 0.072C145.814 0.072 147.614-2.016 147.614-4.680L147.614-33.984C147.614-36.648 145.814-38.736 143.006-38.736C139.478-38.736 138.470-35.568 138.470-34.416C136.526-36.576 131.846-39.024 127.166-39.024C116.078-39.024 108.230-30.240 108.230-19.296C108.230-8.280 116.150 0.360 127.166 0.360ZM138.110-19.296C138.110-12.816 134.366-7.632 127.886-7.632C121.550-7.632 117.734-12.672 117.734-19.296C117.734-25.920 121.622-31.032 127.886-31.032C134.366-31.032 138.110-25.776 138.110-19.296Z" />
          <path d="M194.638-28.656C194.638-29.592 194.278-30.528 193.774-31.248C190.678-35.712 185.422-39.024 177.862-39.024C166.774-39.024 158.854-30.240 158.854-19.296C158.854-8.352 166.846 0.360 177.862 0.360C185.782 0.360 191.038-3.096 194.062-8.136C194.494-8.856 194.926-9.864 194.926-10.872C194.926-13.464 192.910-15.336 190.606-15.336C188.878-15.336 187.726-13.896 187.438-13.392C185.710-10.440 183.190-7.704 178.582-7.704C172.246-7.704 168.358-12.672 168.358-19.296C168.358-25.920 172.318-31.032 178.582-31.032C182.542-31.032 184.486-28.944 186.862-26.064C187.942-24.768 188.878-24.264 190.318-24.264C192.622-24.264 194.638-26.064 194.638-28.656Z" />
          <path d="M210.845-13.968C210.845-5.112 215.957 0.432 224.381 0.432C227.837 0.432 235.469-1.800 235.469-6.912C235.469-9.504 233.453-11.160 231.293-11.160C228.413-11.160 227.981-8.064 224.381-8.064C221.861-8.064 220.349-9.720 220.349-12.888L220.349-30.168L228.125-30.168C230.573-30.168 232.589-31.968 232.589-34.416C232.589-36.864 230.573-38.664 228.125-38.664L220.349-38.664L220.349-48.096C220.349-50.688 218.261-52.848 215.597-52.848C213.005-52.848 210.845-50.688 210.845-48.096L210.845-38.664L205.589-38.664C203.141-38.664 201.197-36.864 201.197-34.416C201.197-31.968 203.141-30.168 205.589-30.168L210.845-30.168Z" />
          <path d="M281.124-19.296C281.124-30.240 272.340-39.024 261.396-39.024C250.524-39.024 241.740-30.240 241.740-19.296C241.740-8.424 250.524 0.360 261.396 0.360C272.340 0.360 281.124-8.424 281.124-19.296ZM271.620-19.296C271.620-12.816 267.876-7.632 261.396-7.632C254.916-7.632 251.244-12.816 251.244-19.296C251.244-25.776 254.916-31.032 261.396-31.032C267.876-31.032 271.620-25.776 271.620-19.296Z" />
          <path d="M325.339-30.384C325.339-36.072 316.627-39.024 312.091-39.024C307.123-39.024 303.163-37.008 301.219-34.848C301.219-37.080 298.771-38.736 296.755-38.736C294.163-38.736 292.003-36.576 292.003-33.984L292.003-4.752C292.003-2.088 294.163 0 296.755 0C299.419 0 301.507-2.088 301.507-4.752L301.507-20.160C301.507-25.416 304.963-31.032 311.083-31.032C317.563-31.032 317.851-26.136 321.091-26.136C323.611-26.136 325.339-27.864 325.339-30.384Z" />
          <path d="M362.354-47.016C362.354-49.752 360.122-52.056 357.314-52.056L339.458-52.056C336.866-52.056 334.778-50.040 334.778-47.448C334.778-44.784 336.866-42.768 339.458-42.768L352.274-42.768L352.274-15.984C352.274-10.584 350.186-7.920 344.786-7.920C339.530-7.920 337.154-10.080 335.066-12.456C334.130-13.536 333.266-14.472 331.898-14.472C329.378-14.472 327.362-12.528 327.362-9.936C327.362-9.144 327.578-8.064 328.154-7.200C330.530-3.528 335.930 0.720 344.930 0.720C355.730 0.720 362.354-5.184 362.354-15.984Z" />
          <path d="M417.946-15.696C417.946-23.904 412.978-28.800 403.402-30.456C401.386-30.816 393.538-32.040 390.874-32.616C386.410-33.552 384.610-35.568 384.610-38.160C384.610-40.968 387.706-44.352 396.418-44.352C400.954-44.352 404.842-42.624 407.578-40.752C409.162-39.672 410.026-39.168 411.394-39.168C413.698-39.168 415.714-41.040 415.714-43.416C415.714-44.856 415.066-46.512 413.194-47.808C408.946-50.904 402.754-52.704 395.986-52.704C382.810-52.704 374.458-46.728 374.458-38.088C374.458-31.176 378.706-25.992 388.570-23.760C391.882-23.040 396.418-22.464 399.226-21.960C405.634-20.736 407.650-18.504 407.650-15.336C407.650-11.232 403.186-7.848 396.130-7.848C390.514-7.848 386.122-9.864 381.658-14.040C380.362-15.264 379.282-15.552 378.418-15.552C375.538-15.552 373.450-13.608 373.450-10.728C373.450-9.576 373.882-8.424 374.674-7.488C379.858-1.800 387.130 0.648 396.130 0.648C409.738 0.648 417.946-5.544 417.946-15.696Z" />
        </g>
      </g>
      <g transform="translate(-197.6774001993158 -106) scale(2)" id="logomark">
        <g fill="#FFFFFF">
          <path d="M40.541 90.855c.362 1.285.729 2.51 1.091 3.674h16.734c.362-1.165.728-2.389 1.091-3.674H40.541z" />
          <path d="M65.094 67.932c3.115-16.265 4.117-34.58-3.607-50.897H38.511c-7.722 16.316-6.723 34.632-3.606 50.897-1.655 2.288-9.073 10.48-9.073 10.48L27.189 100h4.43l3.425-14.012 3.729-1.609c.422 1.574.835 3.089 1.244 4.569h19.965c.407-1.48.823-2.997 1.244-4.569l3.729 1.609L68.38 100h4.431l1.357-21.588s-7.421-8.192-9.074-10.48zM50 29.86c2.665.052 4.808 2.178 4.808 4.807 0 2.626-2.143 4.758-4.808 4.809-2.666-.051-4.808-2.183-4.808-4.809 0-2.629 2.142-4.755 4.808-4.807zM49.974 15.125h10.537C57.853 10.134 50.23 0 49.975 0c-.257 0-7.826 10.134-10.483 15.125h10.482z" />
        </g>
      </g>
    </svg>

    <div
      class="jsx-3403721696 logomark-icons"
      style={{ backgroundColor: 'rgb(35, 35, 35)', gridColumn: '2 / 3' }}
    >
      <div class="jsx-3282769629" />
      <div
        class="lockup"
        style={{ backgroundColor: 'rgb(35, 35, 35)', cursor: 'zoom-in' }}
      >
        <div style={{ paddingTop: '192.308%' }} />
        <svg class="jsx-2263963463 artboard">
          <svg
            viewBox="0 0 50 50"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            class="jsx-2263963463 artboard-inner"
            style={{ width: 55, height: 55, maxHeight: '100%' }}
          >
            <g
              transform="translate(24.75 24.75) scale(1.4285714285714286)"
              id="lockup4-icon"
            >
              <g fill="#FFFFFF">
                <g
                  transform="translate(-17.325 -17.325) scale(0.3431372549019608)"
                  id="container"
                >
                  <g fill="#FFFFFF">
                    <polygon
                      vector-effect="non-scaling-stroke"
                      points="1 101 101 101 101 1 1 1"
                    />{' '}
                  </g>
                </g>
                <g
                  transform="translate(-9.95166438293457 -10.600000000000001) scale(0.2)"
                  id="icon"
                >
                  <g fill="#232323">
                    <path d="M40.541 90.855c.362 1.285.729 2.51 1.091 3.674h16.734c.362-1.165.728-2.389 1.091-3.674H40.541z" />
                    <path d="M65.094 67.932c3.115-16.265 4.117-34.58-3.607-50.897H38.511c-7.722 16.316-6.723 34.632-3.606 50.897-1.655 2.288-9.073 10.48-9.073 10.48L27.189 100h4.43l3.425-14.012 3.729-1.609c.422 1.574.835 3.089 1.244 4.569h19.965c.407-1.48.823-2.997 1.244-4.569l3.729 1.609L68.38 100h4.431l1.357-21.588s-7.421-8.192-9.074-10.48zM50 29.86c2.665.052 4.808 2.178 4.808 4.807 0 2.626-2.143 4.758-4.808 4.809-2.666-.051-4.808-2.183-4.808-4.809 0-2.629 2.142-4.755 4.808-4.807zM49.974 15.125h10.537C57.853 10.134 50.23 0 49.975 0c-.257 0-7.826 10.134-10.483 15.125h10.482z" />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </svg>
      </div>
      <div
        class="lockup"
        style={{ backgroundColor: 'rgb(35, 35, 35)', cursor: 'zoom-in' }}
      >
        <div style={{ paddingTop: '192.308%' }} />
        <svg class="jsx-2263963463 artboard">
          <svg
            viewBox="0 0 50 50"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            class="jsx-2263963463 artboard-inner"
            style={{ width: 55, height: 55, maxHeight: '100%' }}
          >
            <g
              transform="translate(24.75 25) scale(1.4285714285714286)"
              id="lockup4-icon"
            >
              <g fill="#FFFFFF">
                <g
                  transform="translate(-17.325 -17.5) scale(0.35)"
                  id="container"
                >
                  <g fill="#FFFFFF">
                    <rect
                      vector-effect="non-scaling-stroke"
                      x="1"
                      y="1"
                      width="98"
                      height="98"
                      rx="10"
                    />
                  </g>
                </g>
                <g
                  transform="translate(-9.95166438293457 -10.600000000000001) scale(0.2)"
                  id="icon"
                >
                  <g fill="#232323">
                    <path d="M40.541 90.855c.362 1.285.729 2.51 1.091 3.674h16.734c.362-1.165.728-2.389 1.091-3.674H40.541z" />
                    <path d="M65.094 67.932c3.115-16.265 4.117-34.58-3.607-50.897H38.511c-7.722 16.316-6.723 34.632-3.606 50.897-1.655 2.288-9.073 10.48-9.073 10.48L27.189 100h4.43l3.425-14.012 3.729-1.609c.422 1.574.835 3.089 1.244 4.569h19.965c.407-1.48.823-2.997 1.244-4.569l3.729 1.609L68.38 100h4.431l1.357-21.588s-7.421-8.192-9.074-10.48zM50 29.86c2.665.052 4.808 2.178 4.808 4.807 0 2.626-2.143 4.758-4.808 4.809-2.666-.051-4.808-2.183-4.808-4.809 0-2.629 2.142-4.755 4.808-4.807zM49.974 15.125h10.537C57.853 10.134 50.23 0 49.975 0c-.257 0-7.826 10.134-10.483 15.125h10.482z" />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </svg>
      </div>
      <div
        class="lockup"
        style={{ backgroundColor: 'rgb(35, 35, 35)', cursor: 'zoom-in' }}
      >
        <div style={{ paddingTop: '192.308%' }} />
        <svg class="jsx-2263963463 artboard">
          <svg
            viewBox="0 0 50 50"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            class="jsx-2263963463 artboard-inner"
            style={{ width: 55, height: 55, maxHeight: '100%' }}
          >
            <g
              transform="translate(24.75 25) scale(1.4285714285714286)"
              id="lockup4-icon"
            >
              <g fill="#FFFFFF">
                <g
                  transform="translate(-17.325 -17.5) scale(0.3431372549019608)"
                  id="container"
                >
                  <g fill="#FFFFFF">
                    <circle
                      vector-effect="non-scaling-stroke"
                      cx="51"
                      cy="51"
                      r="50"
                    />
                  </g>
                </g>
                <g
                  transform="translate(-9.95166438293457 -10.600000000000001) scale(0.2)"
                  id="icon"
                >
                  <g fill="#232323">
                    <path d="M40.541 90.855c.362 1.285.729 2.51 1.091 3.674h16.734c.362-1.165.728-2.389 1.091-3.674H40.541z" />
                    <path d="M65.094 67.932c3.115-16.265 4.117-34.58-3.607-50.897H38.511c-7.722 16.316-6.723 34.632-3.606 50.897-1.655 2.288-9.073 10.48-9.073 10.48L27.189 100h4.43l3.425-14.012 3.729-1.609c.422 1.574.835 3.089 1.244 4.569h19.965c.407-1.48.823-2.997 1.244-4.569l3.729 1.609L68.38 100h4.431l1.357-21.588s-7.421-8.192-9.074-10.48zM50 29.86c2.665.052 4.808 2.178 4.808 4.807 0 2.626-2.143 4.758-4.808 4.809-2.666-.051-4.808-2.183-4.808-4.809 0-2.629 2.142-4.755 4.808-4.807zM49.974 15.125h10.537C57.853 10.134 50.23 0 49.975 0c-.257 0-7.826 10.134-10.483 15.125h10.482z" />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </svg>
      </div>
      <div
        class="lockup"
        style={{ backgroundColor: 'rgb(35, 35, 35)', cursor: 'zoom-in' }}
      >
        <div style={{ paddingTop: '192.308%' }} />
        <svg class="jsx-2263963463 artboard">
          <svg
            viewBox="0 0 43.137254901960794 50"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            class="jsx-2263963463 artboard-inner"
            style={{ width: 55, height: 55, maxHeight: '100%' }}
          >
            <g
              transform="translate(21.35294117647059 25.000000000000004) scale(1.2324929971988798)"
              id="lockup4-icon"
            >
              <g fill="#FFFFFF">
                <g
                  transform="translate(-17.325 -20.284090909090907) scale(0.3977272727272727)"
                  id="container"
                >
                  <g fill="#FFFFFF">
                    <polygon
                      vector-effect="non-scaling-stroke"
                      transform="translate(44.000000, 51.300001) rotate(90.000000) translate(-44.000000, -51.300001) "
                      points="69 8 94 51.3000014 69 94.6000027 19 94.6000027 -6 51.3000014 19 8"
                    />
                  </g>
                </g>
                <g
                  transform="translate(-9.95166438293457 -10.600000000000001) scale(0.2)"
                  id="icon"
                >
                  <g fill="#232323">
                    <path d="M40.541 90.855c.362 1.285.729 2.51 1.091 3.674h16.734c.362-1.165.728-2.389 1.091-3.674H40.541z" />
                    <path d="M65.094 67.932c3.115-16.265 4.117-34.58-3.607-50.897H38.511c-7.722 16.316-6.723 34.632-3.606 50.897-1.655 2.288-9.073 10.48-9.073 10.48L27.189 100h4.43l3.425-14.012 3.729-1.609c.422 1.574.835 3.089 1.244 4.569h19.965c.407-1.48.823-2.997 1.244-4.569l3.729 1.609L68.38 100h4.431l1.357-21.588s-7.421-8.192-9.074-10.48zM50 29.86c2.665.052 4.808 2.178 4.808 4.807 0 2.626-2.143 4.758-4.808 4.809-2.666-.051-4.808-2.183-4.808-4.809 0-2.629 2.142-4.755 4.808-4.807zM49.974 15.125h10.537C57.853 10.134 50.23 0 49.975 0c-.257 0-7.826 10.134-10.483 15.125h10.482z" />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </svg>
      </div>
      <div
        class="lockup"
        style={{
          backgroundColor: 'rgb(35, 35, 35)',
          cursor: 'zoom-in',
          width: '75%',
          margin: '0px auto'
        }}
      >
        <div style={{ paddingTop: '192.308%' }} />
        <svg class="jsx-2263963463 artboard">
          <svg
            viewBox="0 0 24.167999267578125 50"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            class="jsx-2263963463 artboard-inner"
            style={{ width: 38.6688, height: 80, maxHeight: '100%' }}
          >
            <g
              transform="translate(-12.916001319885254 0) scale(0.5)"
              id="lockup4-icon"
            >
              <g fill="#FFFFFF">
                <path d="M40.541 90.855c.362 1.285.729 2.51 1.091 3.674h16.734c.362-1.165.728-2.389 1.091-3.674H40.541z" />
                <path d="M65.094 67.932c3.115-16.265 4.117-34.58-3.607-50.897H38.511c-7.722 16.316-6.723 34.632-3.606 50.897-1.655 2.288-9.073 10.48-9.073 10.48L27.189 100h4.43l3.425-14.012 3.729-1.609c.422 1.574.835 3.089 1.244 4.569h19.965c.407-1.48.823-2.997 1.244-4.569l3.729 1.609L68.38 100h4.431l1.357-21.588s-7.421-8.192-9.074-10.48zM50 29.86c2.665.052 4.808 2.178 4.808 4.807 0 2.626-2.143 4.758-4.808 4.809-2.666-.051-4.808-2.183-4.808-4.809 0-2.629 2.142-4.755 4.808-4.807zM49.974 15.125h10.537C57.853 10.134 50.23 0 49.975 0c-.257 0-7.826 10.134-10.483 15.125h10.482z" />
              </g>
            </g>
          </svg>
        </svg>
      </div>
    </div>
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js